import { ImportFlow } from "./_components/import-flow";

export const dynamic = "force-dynamic";

export default function ReportTemplatesPage() {
  return (
    <div className="px-6 py-6 lg:px-10">
      <header className="mb-6">
        <h1 className="text-2xl font-semibold">Templates de rapports</h1>
        <p className="text-sm text-muted-foreground">
          Import XLSX → diff vs BDD → application supervisée. Les templates sont
          globaux (partagés par tous les tenants).
        </p>
      </header>

      <section className="mb-6 rounded-lg border border-amber-200 bg-amber-50 p-4 text-sm text-amber-900">
        <p className="font-medium">Stage 1 : upload + diff (lecture seule).</p>
        <p className="mt-1">
          La sélection des modifications et l&apos;application (dry-run puis
          commit) seront ajoutées au stage 2. Pour l&apos;instant cette page
          permet de vérifier le diff XLSX↔BDD sans rien écrire.
        </p>
      </section>

      <ImportFlow />
    </div>
  );
}
